import React from "react";
import arrow from '../img/right_arrow_white.png'

export default class RecapUnfold extends React.Component {

    constructor(props) {
        super(props)
        this.state = {unfolded:false}
        this.bigTitle = 'Vérifier vos informations'
        this.title = 'Vous'
    }

    value(field,deflt='') {

        const {devis} = this.props
        const params = devis.params

        const type = devis.getType(field)
        if ( typeof type === 'object' ) {
            return type[params[field]] || deflt
        }

        return devis.getDisplayValue(field) || deflt
    }

    staticLabel(field,opt={}) {
        const {forceDisplay,forceLabel} = opt
        const devis = this.props.devis
        const value = devis.getDisplayValue(field) 
        const type = devis.getType(field)
        const label = forceLabel || devis.getLabel(field)
        if ( type == 'ouinon' ) {
            return forceDisplay 
            ? <label><b>{label}</b> <span>{(value=='O')?'Oui':((value=='N')?'Non':'à définir')}</span></label>
            : (( value == 'O' )?<label><b>{label}</b></label>:'')
        } else if (( value==='' )&&( !forceDisplay )) return ''
        if ( typeof type === 'object' ) {
            return <label><b>{label}</b> <span>{type[value] || '???'}</span></label>
        }
        return <label><b>{label}</b> <span>{value}</span></label>
    }

    render() {
 
        return <div className="recap_unfold">
            <div className="switcher" onClick={()=>{ this.setState( state => ({unfolded:!state.unfolded}) ) }}>
                <div className="margin"/>
                <div className="centered">
                    <img src={arrow}/>
                    {this.bigTitle}
                </div>
                <div className="margin"/>
            </div>
            <div className={this.state.unfolded?'collapsable':'collapsable hidden'}>
                <div className="recap_unfolded"> 
                    {this.title} <a onClick={()=>this.props.setPage(this.modifyPage)}>Modifier</a>
                    <div className="frame">
                        {this.doRender()}

                    </div>
                </div>
            </div>
        </div>
    }
}
